import SCRIPT_CONTEXT from 'on-running-script-context' // virtual module

window.On = { ...(window.On || {}), ...SCRIPT_CONTEXT }
window.On.helpers = {}
window.On.FormValidationBeforeInit = []
